import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';

import '../../auth.scss';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import SpanComponent from '@sharedComponent/span-component';

const layout = {
	labelCol: { span: 24 },
	wrapperCol: { span: 24 },
};

export const ConfirmPasswordPresentational = ({ state, onFinish }) => {
	const [formRef] = Form.useForm();
	formRef.setFieldsValue({
		userName: state.userName,
		newPassword: state.newPassword,
		confirmPassword: state.confirmPassword,
	});

	return (
		<Row>
			<Col md={{ span: 12 }} lg={{ span: 16 }} sm={{ span: 24 }} className="welcome_img">
				<ImageComponent src={images.welcome} />
			</Col>
			<Col md={{ span: 12 }} lg={{ span: 8 }} sm={{ span: 24 }} className="right_area">
				<Col className="logo_area">
					<ImageComponent src={images.logo_sm} />
				</Col>
				<Col className="sign_in mt-20">
					Set Your Password <SpanComponent>Here </SpanComponent>
				</Col>

				<Form hideRequiredMark={true} style={{ margin: '20px 0px' }} {...layout} layout="vertical" form={formRef} onFinish={onFinish}>
					<Form.Item
						className="noreq"
						name="userName"
						label="Username"
						rules={[
							{
								required: true,
								message: 'Please input your Username !',
							},
							// {
							// 	min: 5,
							// 	message: "Username must be atleast 5 characters"
							// }
							// {
							// 	type: 'email',
							// 	message: "Please input a valid email (Ex: abc@example.com)"
							// }
						]}>
						<Input disabled value={state.userName} />
					</Form.Item>
					<Form.Item
						className="noreq"
						rules={[
							{
								required: true,
								message: 'Please input your Password !',
							},
							{
								min: 8,
								message: 'Password must be a minimum of 8 characters.',
							},
							{
								pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\d@.,$^!%*?&]{8,}$/),
								message: 'Must contain minimum 1 Capitalcase letter, 1 Lowercase letter & 1 Special characters',
							},
						]}
						name="newPassword"
						label="Password">
						<Input.Password />
					</Form.Item>
					<Form.Item
						className="noreq"
						rules={[
							{
								required: true,
								message: 'Please input your Password !',
							},
							{
								min: 8,
								message: 'Password must be a minimum of 8 characters.',
							},
							{
								pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\d@.,$^!%*?&]{8,}$/),
								message: 'Must contain 1 uppercase letter, 1 lowercase letter and a number and/or special character. ',
							},
						]}
						name="confirmPassword"
						label="Confirm Password">
						<Input.Password />
					</Form.Item>
					<Form.Item style={{ margin: ' 15px 0px' }}>
						<Button loading={state.buttonLoading} className="k_btn" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
					<Col className="first_time mt-30">
						By logging in, You agree to the <SpanComponent>terms of services</SpanComponent>
					</Col>
				</Form>
			</Col>
		</Row>
	);
};
